var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPhotographOutline(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M2.66675 10.6667L5.72408 7.60933C5.97412 7.35937 6.3132 7.21895 6.66675 7.21895C7.0203 7.21895 7.35938 7.35937 7.60941 7.60933L10.6667 10.6667M9.33341 9.33333L10.3907 8.276C10.6408 8.02604 10.9799 7.88562 11.3334 7.88562C11.687 7.88562 12.026 8.02604 12.2761 8.276L13.3334 9.33333M9.33341 5.33333H9.34008M4.00008 13.3333H12.0001C12.3537 13.3333 12.6928 13.1929 12.9429 12.9428C13.1929 12.6928 13.3334 12.3536 13.3334 12V4C13.3334 3.64638 13.1929 3.30724 12.9429 3.05719C12.6928 2.80714 12.3537 2.66667 12.0001 2.66667H4.00008C3.64646 2.66667 3.30732 2.80714 3.05727 3.05719C2.80722 3.30724 2.66675 3.64638 2.66675 4V12C2.66675 12.3536 2.80722 12.6928 3.05727 12.9428C3.30732 13.1929 3.64646 13.3333 4.00008 13.3333Z",
    stroke: "#09090B",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPhotographOutline);
export default __webpack_public_path__ + "static/media/PhotographOutline.b7297d2b720f6bcb1a5ecc8cc62301ff.svg";
export { ForwardRef as ReactComponent };